import React, { Component, createRef, type ReactNode, type RefObject } from 'react';
import { Animation } from '@babylonjs/core/Animations/animation';
import { BezierCurveEase, EasingFunction } from '@babylonjs/core/Animations/easing';
import type { ArcRotateCamera } from '@babylonjs/core/Cameras/arcRotateCamera';
import log from 'loglevel';
// import {
//   onGarmentReadyRecomputeHeatMaps,
//   onGarmentReadyUpdateSceneAvatarCoverage,
// } from "../actions/homeViewport";
// import { SceneModule } from "../scene/sceneModule";
import type { FitroomViewportContext } from '../fitroomViewportContext';
import { fitroomViewportModuleContext } from '../fitroomViewportModule';
import * as S from './fitroomViewport.styles';

export interface FitroomViewportProps {
  name?: string;
}

export class FitroomViewport extends Component<FitroomViewportProps> {
  private readonly _canvas: RefObject<HTMLCanvasElement>;

  private readonly _context: FitroomViewportContext;

  private readonly _onGarmentReadyCallbackBind: (context: FitroomViewportContext) => void;

  constructor(props: FitroomViewportProps) {
    super(props);
    this._canvas = createRef<HTMLCanvasElement>();
    this._context = fitroomViewportModuleContext(props.name ?? 'DEFAULT');
    this._onGarmentReadyCallbackBind = this._onGarmentReadyCallback.bind(this);
  }

  componentDidMount(): void {
    const canvas = this._canvas.current!;
    // init viewport context
    this._context.init(canvas);
    this._context.registerGarmentReady(this._onGarmentReadyCallbackBind);
    // run render loop
    this._context.runRenderLoop();
  }

  componentWillUnmount(): void {
    // TODO: Disconnect resize handler
    // this._context.dispose();
  }

  async componentDidUpdate(prevProps: FitroomViewportProps): Promise<void> {
    // const { scene: nextScene } = this.props;
    // const { scene: prevScene } = prevProps;
    // // Update scene
    // if (nextScene !== prevScene) {
    //   this._updateScene(nextScene, prevScene);
    // }
  }

  render(): ReactNode {
    return <S.Canvas ref={this._canvas} />;
  }

  private _onGarmentReadyCallback(context: FitroomViewportContext): void {
    // dirty notify
    this._context.core.markDirty();
    // 0. scene avatar coverage update from garment
    // 1. recompute heat maps
    // await Promise.all([
    //   onGarmentReadyUpdateSceneAvatarCoverage(context),
    //   onGarmentReadyRecomputeHeatMaps(context),
    // ]);
  }

  // private _updateAvatar(nextScene: IScene): void {
  //   const nextEntity = nextScene.children.find(
  //     (entity: ISceneEntity) => !!entity.components.avatar
  //   );
  //   const mesh = nextEntity.components.mesh.mesh as any;
  //   this._context.updateAvatar(mesh.geometry);
  // }

  private _updateCamera(alpha: number): void {
    log.info('update viewport camera');
    const babylonScene = this._context.core.scene;

    const camera = babylonScene.activeCamera as ArcRotateCamera;
    const prevBeta = camera.beta;
    let prevAlpha = camera.alpha;
    let nextAlpha = alpha;

    const { center, radius } = this._context.getGarmentCenter();

    if (alpha === 0 && prevAlpha > Math.PI) {
      nextAlpha = 2 * Math.PI;
    }
    if (prevAlpha === 0 && alpha > Math.PI) {
      prevAlpha = 2 * Math.PI;
    }

    const ease = new BezierCurveEase(0.05, 0.1, 0.9, 0.95);
    ease.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);

    const alphaAnimation = Animation.CreateAnimation(
      'alpha',
      Animation.ANIMATIONTYPE_FLOAT,
      60,
      ease,
    );
    alphaAnimation.setKeys([
      { frame: 0, value: prevAlpha },
      { frame: 100, value: nextAlpha },
    ]);

    const betaAnimation = Animation.CreateAnimation(
      'beta',
      Animation.ANIMATIONTYPE_FLOAT,
      60,
      ease,
    );
    betaAnimation.setKeys([
      { frame: 0, value: prevBeta },
      { frame: 100, value: 1.4056476493802699 },
    ]);

    const radiusAnimation = Animation.CreateAnimation(
      'radius',
      Animation.ANIMATIONTYPE_FLOAT,
      60,
      ease,
    );
    radiusAnimation.setKeys([
      { frame: 0, value: camera.radius },
      { frame: 100, value: radius + 1 },
    ]);

    const targetAnimation = Animation.CreateAnimation(
      'target',
      Animation.ANIMATIONTYPE_VECTOR3,
      60,
      ease,
    );
    targetAnimation.setKeys([
      { frame: 0, value: camera.target },
      { frame: 100, value: center },
    ]);

    camera.animations = [alphaAnimation, betaAnimation, radiusAnimation, targetAnimation];

    babylonScene.beginAnimation(camera, 0, 100, false, 4, () => {
      if (nextAlpha === 2 * Math.PI) {
        camera.alpha = 0;
      }
    });
  }

  // private async _updateScene(
  //   nextScene: HomeSceneState,
  //   prevScene?: HomeSceneState
  // ) {
  //   const isViewChanged = HomeSceneState.hasViewChanged(nextScene, prevScene);

  //   if (isViewChanged) {
  //     this._updateCamera(nextScene.viewAlpha);
  //   }

  //   const isAvatarChanged = HomeSceneState.hasAvatarChanged(
  //     nextScene,
  //     prevScene
  //   );
  //   const isGarmentChanged = HomeSceneState.hasGarmentChanged(
  //     nextScene,
  //     prevScene
  //   );
  //   const sceneContext = SceneModule.context;
  //   const scene = sceneContext.scene;

  //   if (isAvatarChanged || isGarmentChanged) {
  //     await this._context.removeGarment();
  //   }
  //   if (HomeSceneState.hasAvatarTextureChanged(nextScene, prevScene)) {
  //     this._context.updateAvatarMaterial(sceneContext.avatarTextures);
  //   }
  //   if (isAvatarChanged) {
  //     this._updateAvatar(scene);
  //   }
  //   if (isGarmentChanged) {
  //     this._context.createGarment(scene);
  //   }

  //   this._core.markDirty();
  // }
}
